// extracted by mini-css-extract-plugin
export default {"Ribbon":"CardRibbon_Ribbon__v0grO","NoRibbon":"CardRibbon_NoRibbon__VVmOw"};